// extracted by mini-css-extract-plugin
module.exports = {"primary":"#152456"};